export default {
  getControlTowerComexTableHeaders(state) {
    return state.controlTowerComexTableHeaders;
  },
  getControlTowerComexTableItens(state) {
    return state.controlTowerComexTableItens;
  },
  getAnalistasProcessos(state) {
    return state.analistasProcessos;
  },
  getFiltros(state) {
    return state.filtros;
  },
};
